import * as AuthenticationTypes from "../Constants/AuthenticationTypes";
import { SERVER_NAMES } from "../Constants/AuthenticationTypes";

export { AUTHENTICATION_TYPES } from "../Constants/AuthenticationTypes";

export const filterRainbowAuthentication = (authenticationArray) => {
    return authenticationArray.filter((object) => object.type === AuthenticationTypes.AUTHENTICATION_TYPES.RAINBOW);;
}

export const isRainbowAuthentication = (account) => {
    if (account == null || account.environment == null || account.environment.length === 0 || account.authentication == null || account.authentication.length === 0 || account.selectedLoginIndex >= account.authentication?.length) {
        return false;
    }
    return account.authentication[account.selectedLoginIndex].type === AuthenticationTypes.AUTHENTICATION_TYPES.RAINBOW;
}

export const isSamlAuthentication = (account) => {
    if (account == null || account.environment == null || account.environment.length === 0 || account.authentication == null || account.authentication.length === 0 || account.selectedLoginIndex >= account.authentication?.length) {
        return false;
    }
    return account.authentication[account.selectedLoginIndex].type === AuthenticationTypes.AUTHENTICATION_TYPES.SAML;
}

export const isOidcAuthentication = (account) => {
    if (account == null || account.environment == null || account.environment.length === 0 || account.authentication == null || account.authentication.length === 0 || account.selectedLoginIndex >= account.authentication.length) {
        return false;
    }
    return account.authentication[account.selectedLoginIndex].type === AuthenticationTypes.AUTHENTICATION_TYPES.OIDC;
}

export const isSsoAuthentication = (account) => {
    return isSamlAuthentication(account) || isOidcAuthentication(account);
}

export const getBaseServerUrl = (account) => {
    if (!account) {
        return null;
    }
    return account.baseServerUrl;
}

export const getSelectedServerUrl = (account) => {
    if (!account || account.selectedServerIndex >= account.environment.length) {
        return null;
    }
    return account.environment[account.selectedServerIndex].environmentApiUrl;
}

export const isEnvironmentAvailable = (account) => {
    if (!account || !account.environment) {
        return false;
    }
    return account.environment.length > 0;
}

export const isAuthenticationAvailable = (account) => {
    if (!account || !account.authentication) {
        return false;
    }
    return account.authentication.length > 0;
}

export const getSelectedLoginUrl = (account) => {
    if (!account || account.selectedLoginIndex >= account.authentication.length) {
        return null;
    }
    return account.authentication[account.selectedLoginIndex].loginUrl;
}

export const getSelectedLogoutUrl = (account) => {
    if (!account || account.selectedLoginIndex >= account.authentication.length) {
        return null;
    }
    return account.authentication[account.selectedLoginIndex].logoutUrl;
}

// export const isAuthenticated = (account) => {
//     if (!account) {
//         return false;
//     }
//     return account.token ? true : false;
// }

export const isPointComServer = (server) => {
    if (!server) {
        return false;
    }
    return server.indexOf(SERVER_NAMES.COM) >= 0;
}

export const isPointComCnServer = (server) => {
    if (!server) {
        return false;
    }
    return server.indexOf(SERVER_NAMES.COM_CN) >= 0;
}

export const isPointHealthServer = (server) => {
    if (!server) {
        return false;
    }
    return server.indexOf(SERVER_NAMES.HEALTH) >= 0;
}

export const isPointNetServer = (server) => {
    if (!server) {
        return false;
    }
    return server.indexOf(SERVER_NAMES.NET) >= 0;
}

export const isPointCpaasServer = (server) => {
    if (!server) {
        return false;
    }
    return server.indexOf(SERVER_NAMES.CPAAS) >= 0;
}

export const isPointOrgServer = (server) => {
    if (!server) {
        return false;
    }
    return server.indexOf(SERVER_NAMES.ORG) >= 0;
}

export const isMonacoServer = (server) => {
    if (!server) {
        return false;
    }
    return server.indexOf(SERVER_NAMES.MONACO) >= 0;
}

export const getWrapper = (loginUrl) => {
    let wrapped = "";
    if (isPointComServer(loginUrl) || isPointComCnServer(loginUrl) || isMonacoServer(loginUrl)) {
        wrapped = "Gd49LLdJA8YQo0w7B4jNS2RQrl0NstLm7BbhgwIKs8KcnoAvtD3m1CRZ7gOIWIww";
    } else if (isPointNetServer(loginUrl) || isPointCpaasServer(loginUrl) || isPointOrgServer(loginUrl)) {
        wrapped = "zTACLLI0dg28KbWhW5EUQxpM30u0TbQblqPJPEaumqYJAMluKUyt1vcBox3mWVyq";
    } else if (isPointHealthServer(loginUrl)) {
        wrapped = "MCj0csdpj8wZd34i2CXcn7QmtKWNO931DSU2DO777tuVnlZwMfVDAOSieVi9GV5N";
    }
    return wrapped;
}
